/*
  TMA — heat filters on the curry line-up.

  Progressive enhancement. The chips ship hidden and are only revealed once
  this script runs, so a visitor without JavaScript sees every product rather
  than a filtered subset with no way to clear it.

  Filtering is presentational: cards are hidden with the `hidden` attribute,
  never removed, so the add-to-cart forms inside them stay in the DOM and
  tma-cart.js keeps working on whatever is visible.

  Heat comes from data-heat on the card, written by tma-2026-card.liquid from
  custom.spice_level. A product with no spice level is `unknown` and shows
  under All only — it is never claimed to be mild.
*/
(function () {
  var groups = document.querySelectorAll('[data-tma-filters]');
  if (!groups.length) return;

  groups.forEach(function (bar) {
    var section = bar.closest('.t26-line') || document;
    var grid = section.querySelector('[data-tma-filterable]');
    if (!grid) return;

    var cards = [].slice.call(grid.querySelectorAll('.t26-pc'));
    var chips = [].slice.call(bar.querySelectorAll('[data-heat-filter]'));

    /* Drop a chip nothing matches rather than offering an empty result. */
    chips.forEach(function (chip) {
      var want = chip.getAttribute('data-heat-filter');
      if (want === 'all') return;
      var any = cards.some(function (c) { return c.getAttribute('data-heat') === want; });
      if (!any) chip.remove();
    });

    /* One usable filter is not a filter. */
    if (bar.querySelectorAll('[data-heat-filter]').length < 3) return;

    bar.hidden = false;

    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-heat-filter]');
      if (!chip) return;
      var want = chip.getAttribute('data-heat-filter');

      [].slice.call(bar.querySelectorAll('[data-heat-filter]')).forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var shown = 0;
      cards.forEach(function (card) {
        var match = want === 'all' || card.getAttribute('data-heat') === want;
        card.hidden = !match;
        if (match) shown++;
      });

      /* Announce the result; a silent grid change is invisible to a screen
         reader and easy to miss on a phone. */
      var live = section.querySelector('[data-tma-filter-status]');
      if (live) {
        live.textContent = want === 'all'
          ? 'Showing all ' + shown + ' mixes.'
          : 'Showing ' + shown + ' ' + want + ' ' + (shown === 1 ? 'mix' : 'mixes') + '.';
      }
    });
  });
})();
